import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function Redirection() {
    return (
        <div className={globalStyles.article}>
            <h1>Redirection</h1>
            <p>File descriptor 0 is stdin, 1 is stdout, 2 is stderr — redirection just rewires where those
                streams go.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '500px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Effect</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>cmd &gt; file</code></td>
                        <td>Redirect stdout to file, overwriting it</td>
                    </tr>
                    <tr>
                        <td><code>cmd &gt;&gt; file</code></td>
                        <td>Redirect stdout to file, appending</td>
                    </tr>
                    <tr>
                        <td><code>cmd 2&gt; file</code></td>
                        <td>Redirect stderr only</td>
                    </tr>
                    <tr>
                        <td><code>cmd &gt; file 2&gt;&amp;1</code></td>
                        <td>Redirect stdout to file, then point stderr at wherever stdout now goes</td>
                    </tr>
                    <tr>
                        <td><code>cmd &amp;&gt; file</code></td>
                        <td>Shorthand for both stdout and stderr to file (bash-specific)</td>
                    </tr>
                    <tr>
                        <td><code>cmd &gt; /dev/null 2&gt;&amp;1</code></td>
                        <td>Discard all output</td>
                    </tr>
                    <tr>
                        <td><code>cmd &lt; file</code></td>
                        <td>Feed file as stdin</td>
                    </tr>
                    <tr>
                        <td><code>cmd | tee file</code></td>
                        <td>Write stdout to file <em>and</em> pass it through to the next command</td>
                    </tr>
                    <tr>
                        <td><code>cmd 2&gt;&amp;1 | less</code></td>
                        <td>Merge stderr into stdout before piping (order matters — must come before the pipe)</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Why order matters</h3>
            <pre className={globalStyles.code}>
                <code>
                    <span style={{opacity: 0.7}}># Wrong: stderr still goes to the terminal — at this point</span><br/>
                    <span style={{opacity: 0.7}}># fd 2 is duplicated to the OLD stdout (the terminal), then</span><br/>
                    <span style={{opacity: 0.7}}># stdout is redirected to the file</span><br/>
                    cmd 2&gt;&amp;1 &gt; file<br/>
                    <br/>
                    <span style={{opacity: 0.7}}># Right: redirect stdout first, then point stderr at it</span><br/>
                    cmd &gt; file 2&gt;&amp;1
                </code>
            </pre>

            <h3>Custom file descriptors</h3>
            <pre className={globalStyles.code}>
                <code>
                    exec 3&gt; log.txt&nbsp;&nbsp;<span style={{opacity: 0.7}}># open fd 3 for writing</span><br/>
                    echo "hello" &gt;&amp;3<br/>
                    exec 3&gt;&amp;-&nbsp;&nbsp;<span style={{opacity: 0.7}}># close fd 3</span>
                </code>
            </pre>
        </div>
    )
}
